import { data, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TrialTranscriptionModal from "./TrialTranscriptionModal";
import HttpManager from "../utils/HttpManager";

function Home() {

    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [user, setUser] = useState(null);

    // Load user from localStorage on component mount
    useEffect(() => {
        const storedUser = localStorage.getItem('User');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    return (
        <>
            <main>
                <div className="px-4 py-4 text-center">
                    {/* <p className="lead float-end" >
                        Already a member? <Link to="/Login" className=" px-4 float-end" style={{textDecoration:"none"}}>Login</Link>
                    </p> */}
                    <p
                        className="lead"
                        style={{
                            position: "fixed",
                            top: "20px",
                            right: "20px",
                            zIndex: 9,
                            // background: "#fff",
                            padding: "0.5rem 1rem",
                            // borderRadius: "6px",
                            // boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                        }}
                    >
                        {
                            user &&
                            <nav className="d-inline-flex mt-2 mt-md-0 ms-md-auto">
                                {/* <Link to="/Pricing/#features" className="me-3 py-2 link-body-emphasis text-decoration-none text-start" href="#">Dashboard</Link> */}

                                {
                                    user &&
                                    <Link to="/Dashboard" className="me-3 py-2 link-body-emphasis text-decoration-none" href="#">Dashboad</Link>
                                }
                                <Link to="/Pricing" className="me-3 py-2 link-body-emphasis text-decoration-none" href="#">Pricing</Link>
                                <Link to="/AboutUs" className="me-3 py-2 link-body-emphasis text-decoration-none" href="#">About Us</Link>
                                {
                                    user &&
                                    (
                                        <>
                                            <Link to="#" className="py-2 link-body-emphasis text-decoration-none text-danger" href="#" onClick={async (e) => {
                                                e.preventDefault();
                                                // Clear localStorage
                                                localStorage.removeItem("User");
                                                // Dispatch logout event to update <Header />
                                                window.dispatchEvent(new Event('logout'));
                                                await new HttpManager(navigate).get("/User/Logout", {});
                                                navigate("/Login");
                                            }} >Logout</Link>
                                        </>
                                    )
                                }

                            </nav>
                        }

                        {
                            !user &&
                            <>
                                Already a member?
                                <Link
                                    to="/Login"
                                    className="px-2"
                                    style={{ textDecoration: "none", fontWeight: "bold" }}
                                >
                                    Login
                                </Link>
                            </>
                        }
                    </p>
                    <img className="d-block mx-auto my-5" src="/DecipherX_Logo1.svg" alt="" width="132" height="107" />
                    <h3 className="display-6 fw-bold text-body-emphasis">AI-Powered Accuracy. Seamless Integration. Real-Time Results.</h3>
                    <div className="col-lg-6 mx-auto">
                        <p className="lead mb-4">Specialized in audio transcription and image CAPTCHA processing with enterprise-grade reliability.</p>
                        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                            <button type="button" className="btn btn-outline-primary btn-lg px-4" onClick={() => setShowModal(true)}>Demo</button>
                            <Link to="/Pricing" className="btn btn-outline-secondary btn-lg px-4">Get Started</Link>
                        </div>
                    </div>
                </div>
                <div className="container px-4 py-4">
                    <h2 className="pb-2 border-bottom"></h2>

                    <div className="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-4">
                        {/* <div className="col d-flex flex-column align-items-start gap-2">
                        <h2 className="fw-bold text-body-emphasis">Left-aligned title explaining these awesome features</h2>
                        <p className="text-body-secondary">Paragraph of text beneath the heading to explain the heading. We'll add onto it with another sentence and probably just keep going until we run out of words.</p>
                        
                    </div> */}
                        <div className="col d-flex flex-column align-items-start gap-2">
                            <h2 className="fw-bold text-body-emphasis">Advanced Audio Transcription & CAPTCHA Solving</h2>
                            <p className="text-body-secondary">
                                Harness the power of AI to convert audio into accurate, readable text and automate complex CAPTCHA challenges with ease.
                                Our solutions are built for speed, scalability, and precision—designed to seamlessly integrate into your digital workflows.
                            </p>
                        </div>

                        <div className="col">
                            <div className="row row-cols-1 row-cols-sm-2 g-4">
                                <div className="col d-flex flex-column gap-2">
                                    <div className="feature-icon-small d-inline-flex align-items-center justify-content-center bg-gradient fs-1 rounded-3">
                                        <div className="feature-icon mb-3">🔊</div>
                                    </div>
                                    <h4 className="fw-semibold mb-0 text-body-emphasis">Audio Transcription</h4>
                                    <p className="text-body-secondary"><ul className="list-unstyled">
                                        <li>✔️ Real-time & batch processing</li>
                                        {/* <li>✔️ Speaker identification</li> */}
                                        <li>✔️ Noise-resistant transcription</li>
                                        <li>✔️ API access for automation</li>
                                    </ul></p>
                                </div>

                                <div className="col d-flex flex-column gap-2">
                                    <div className="feature-icon-small d-inline-flex align-items-center justify-content-center bg-gradient fs-1 rounded-3">
                                        <div className="feature-icon mb-3">🧩</div>
                                    </div>
                                    <h4 className="fw-semibold mb-0 text-body-emphasis">Image CAPTCHA Processing</h4>
                                    <p className="text-body-secondary"><ul className="list-unstyled">
                                        <li>✔️ Text & image CAPTCHA support</li>
                                        <li>✔️ High-resolution decoding</li>
                                        <li>✔️ Custom formats supported</li>
                                        <li>✔️ Scalable API for enterprise</li>
                                    </ul></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Why Us Section --> */}
                    <section className="row-cols-md-12 col d-flex py-4" id="why-us">
                        <div className="container">
                            <div className="row text-center mb-4">
                                <div className="col">
                                    <h2 className="fw-bold">Why Choose Us?</h2>
                                </div>
                            </div>
                            <div className="row g-4 text-center">
                                <div className="col-md-3"><p>✅ <strong>Enterprise-Grade Accuracy</strong></p></div>
                                <div className="col-md-3"><p>⚙️ <strong>Easy API Integration</strong></p></div>
                                <div className="col-md-3"><p>🔐 <strong>Privacy-Focused Infrastructure</strong></p></div>
                                <div className="col-md-3"><p>📈 <strong>Scalable to Your Needs</strong></p></div>
                            </div>
                        </div>
                    </section>

                    {/* <!-- Call to Action --> */}
                    <section className="row-cols-md-12 col d-flex cta-section text-center" id="contact">
                        <div className="container">
                            <h2 className="fw-bold">Get Started Today</h2>
                            <p className="lead">Whether you're a developer or enterprise—let us help you automate with AI.</p>
                            {/* <button type="button" className="btn btn-outline-secondary btn-sm px-4">Get Started</button> */}
                            <Link to="/Pricing" className="btn btn-outline-secondary btn-sm px-4">Get Started</Link>
                        </div>
                    </section>

                </div>
            </main>
            <div className="container py-3">
                <Footer />
            </div>
            {/* Custom Modal (React-controlled) */}
            {
                showModal && (<TrialTranscriptionModal setShowModal={setShowModal} />)
            }
        </>
    );
}



export default Home;